function escapeHtml(s) {
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function linkifyPlainText(text) {
    if (text === null || text === undefined) return '';
    const raw = String(text);
    const re = /https?:\/\/[^\s<]+/gi;
    const parts = [];
    let lastIndex = 0;
    let m;
    while ((m = re.exec(raw)) !== null) {
        parts.push(escapeHtml(raw.slice(lastIndex, m.index)));
        const url = m[0];
        parts.push(
            `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer" class="edc-linkified">${escapeHtml(url)}</a>`,
        );
        lastIndex = m.index + url.length;
    }
    parts.push(escapeHtml(raw.slice(lastIndex)));
    return parts.join('').replace(/\r\n|\r|\n/g, '<br>');
}

export { escapeHtml, linkifyPlainText };
